var _path, _path2, _line, _line2, _line3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubjecticon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9994 2.10447V18.1981C19.9994 18.3432 19.9708 18.4868 19.9153 18.6208C19.8598 18.7548 19.7784 18.8765 19.6759 18.9791C19.5733 19.0817 19.4516 19.163 19.3176 19.2185C19.1836 19.274 19.04 19.3026 18.8949 19.3026H17.4749V4.83934C17.4749 4.54868 17.3603 4.26973 17.1561 4.06297C16.9518 3.85622 16.6742 3.73833 16.3836 3.73487H3.52441V2.10447C3.52783 1.8126 3.64529 1.53366 3.85168 1.32727C4.05807 1.12087 4.33702 1.00341 4.62888 1H18.8949C19.1868 1.00341 19.4657 1.12087 19.6721 1.32727C19.8785 1.53366 19.996 1.8126 19.9994 2.10447Z",
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3705 3.73486H2.10447C1.49449 3.73486 1 4.22935 1 4.83933V20.933C1 21.543 1.49449 22.0375 2.10447 22.0375H16.3705C16.9805 22.0375 17.475 21.543 17.475 20.933V4.83933C17.475 4.22935 16.9805 3.73486 16.3705 3.73486Z",
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.85928,
    y1: 6.97422,
    x2: 10.9186,
    y2: 6.97422,
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.22964,
    y1: 12.2335,
    x2: 13.5484,
    y2: 12.2335,
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.22964,
    y1: 17.493,
    x2: 8.28901,
    y2: 17.493,
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2039 16.7782L11.3726 18.0931L13.7101 15.4634",
    stroke: "#303030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubjecticon);
export default __webpack_public_path__ + "static/media/subjecticon.0a607ca546c29c076b84f7d8fd58f8bb.svg";
export { ForwardRef as ReactComponent };